import { registerBottomSheets, BottomSheetComponent } from '@bonanza-social/navigation';
import PrizeWallPrizeInfo from '../components/PrizeWallPrizeInfo/PrizeWallPrizeInfo';
import PrizeWallFinished from '../components/PrizeWallFinished/PrizeWallFinished';

const bottomSheets = {
  PrizeWallPrizeInfo,
  PrizeWallFinished,
};

registerBottomSheets('prizeWall', bottomSheets);

declare global {
  interface RegisteredBottomSheets {
    prizeWall: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}
